module.exports = __webpack_public_path__ + "static/logo_tci-573e9c21cd9432de7ac0bd42065a7c2b.png";